<template id="filteroptions">
  <div class="leftsidebar stickyfooter">
    <!--Mobile Footer Filter Options-->
    <div class="thm1 filteroption" v-if="!$parent.$parent.isDesktop && this.filters.options.length > 0">
      <div class="col-12 w-100" style="height: 39px;border-top: 1px solid #d9d9d9;" v-if="mobileFilterVisible">
        <div v-if="showHamburgerMenuIcon" :class=" !showHamburgerMenuIcon  ? 'col-md-6 col-sm-6 col-6' : 'col-md-4 col-sm-4 col-4'" style="border-right:1px solid #d9d9d9;">
          <button type="button" class="btn w-100 lightDark-text card-removeButton text-uppercase" @click="openSideNav()">
            <img class="mb-1 mr-1" style="width:16px;height: 16px;image-rendering: auto;" :src="require('@/assets/images/hamburger-bleack.svg')" alt="-"/>
            Menu
          </button>
          <SideNav :isOpen="showSideNav" @close="showSideNav = false" :isDesktop="$parent.$parent.isDesktop "></SideNav>
        </div>
        <div :class=" !showHamburgerMenuIcon  ? 'col-md-6 col-sm-6 col-6' : 'col-md-4 col-sm-4 col-4'" style="border-right:1px solid #d9d9d9;">
          <button type="button" class="btn w-100 lightDark-text card-removeButton text-uppercase" @click="toggleFilter('filter')">
            <img class="mb-1 mr-1" style="width:16px;height: 16px;image-rendering: auto;" :data-src="staticImg + 'filterIcons/ic_filter.png'" alt="Filter"/>
            Filter <span v-if="isFilterApplied" class="dot"></span>
          </button>
        </div>
        <!-- <div v-if="isKids && ageGroups && ageGroups.length && isShowAgeModal" :class="(!isShowAgeModal || !isKids) || (ageGroups && !ageGroups.length) ? 'col-md-6 col-sm-6 col-6' : 'col-md-4 col-sm-4 col-4'" style="border-right:1px solid #d9d9d9;">
          <button type="button" class="btn w-100 lightDark-text card-removeButton text-uppercase" @click="toggleFilter('age')">
            Age <span v-if="isAgeGroupFilterApplied" class="dot"></span>
          </button>
        </div> -->
        <div :class="!showHamburgerMenuIcon ? 'col-md-6 col-sm-6 col-6' : 'col-md-4 col-sm-4 col-4'">
          <button type="button" class="btn w-100 lightDark-text card-removeButton text-uppercase" @click="toggleFilter('sort')">
            <img class="mb-1 mr-1" style="width:27px;height: 17px;image-rendering: auto;" :data-src="staticImg + 'filterIcons/ic_sort.png'" alt="Sort"/>
            Sort
          </button>
        </div>
      </div>
      <!-- filter Ui mobile action buttons -->
      <div id="filter-mobile-btns" class="col-12 w-100" style="height: 39px;border-top: 2px solid #d9d9d9;" v-if="isFilterVisible">
        <div class="col-md-6 col-sm-6 col-6" style="border-right:1px solid #d9d9d9;">
            <button type="button" class="btn w-100 card-removeButton text-uppercase dark-text font-weight-bold" @click="closeFilterModal()">Close</button>
        </div>
        <div class="col-md-6 col-sm-6 col-6">
            <button type="button" class="btn w-100 card-removeButton text-uppercase font-weight-bold" @click="applyFilters()">Apply</button>
        </div>
      </div>
    </div>
    <!--Filters-->
    <div class="filtersection" ref="filtersContainer">
      <!-- dont show sort filter list coming from graphql use sort from vue state -->
      <div class="filteroptionsModal" id="filter" v-if="$parent.$parent.isDesktop">
  <!-- Hardcoded Gender Radio Buttons -->
   <div v-if="isShowAutoGenderSwitch && otherFilterOptionsData.length>0">
     <div class="headig-top">Gender</div>
     <div class="customradio gender-radiobtn">
       <label class="d-flex align-items-center label-wrapper">
         <input
           type="radio"
           name="gender"
           value="1"
           v-model="selectedFilters['gender']"
           @change="applyFilters()"
         />
         <span class="priceColor">Men</span>
       </label>
       <label class="d-flex align-items-center label-wrapper">
         <input
           type="radio"
           name="gender"
           value="2"
           v-model="selectedFilters['gender']"
           @change="applyFilters()"
         />
         <span class="priceColor">Women</span>
       </label>
       <label class="d-flex align-items-center label-wrapper">
         <input
           type="radio"
           name="gender"
           value="3"
           v-model="selectedFilters['gender']"
           @change="applyFilters()"
         />
         <!-- <span class="priceColor">Kids</span> -->
       </label>
     </div>
    </div>


        <div :title="filter.alias" subtitle="" v-for="(filter, index) in otherFilterOptionsData" :key="index" :class="{'activewear-landing': (callerComp === 'activeWearLandingPage' || callerComp === 'winterWearLandingPage') ? 'supima-landing': callerComp === 'supimaLandingPage'}">
          <div v-if="filter.alias !== 'Themes' && (!isShowAutoGenderSwitch || filter.alias !== 'Gender') && (!(filter.alias === 'Size' && isKids) || (filter.alias === 'Size' && isSelectedCountryIndia && enableVincenzeSearch && isKids && callerComp === 'Search Page'))">
          <div class="headig-top">{{ filter.alias }}</div>
          <input type="text" class="form-control input-sm filter-search" v-model="filter.tr"
              v-if="filter.options.length > 5" :placeholder="`Search for ${filter.alias}`" @input="onSearchChange($event, filter)"/>
          <div class="maxer" v-if="filter.alias ==='Gender' || filter.alias === 'Stock'">
            <div class="customradio radiobtn" v-for="(item, index4) in filter.options.filter(item => searchMatch(item,filter.tr))" :key="index4" >
              <label class="d-flex align-items-center label-wrapper">
                <input type="radio"
                  :name="filter.field"
                  :value="item.slug"
                  v-model="selectedFilters[filter.field]"
                  @change="applyFilters()"
                  :rel="item.name"
                />
                <span class="priceColor">{{item.name}}</span>
                <span class="price-count" v-if="isShowOptionFilterCount">{{item.count ? item.count : ''}}</span>
              </label>
            </div>
          </div>
          <div class="maxer" :class="filter.alias === 'Size' ? 'd-flex flex-wrap size-filter' : ''" v-else>
            <div v-show="searchArraydData[filter.alias] === ''">
            <div class="customcheckbox" v-for="(item, newIndex) in filter.options" :key="'filter' + newIndex">
              <input type="checkbox" v-model="item.use" @change="applyFilters()">
              <label class="d-flex align-items-center label-wrapper">
                <span v-if="filter.field === 'colors' || filter.field === 'color'" class="color-icon-label" :style="{ backgroundColor: item.hex || item.slug }" :class="{'color-icon-border': item.slug === '#ffffff' || !item.slug}"></span>
                <div class="count-filter" v-if="filter.alias !== 'Size' "> 
                  <span class="count-filter-label">{{ item.name }}</span>
                  <span class="count-text" v-if="isShowOptionFilterCount">{{item.count ? item.count : ''}}</span>
                </div>
                <div v-else class="size-count-filter">
                  <span>{{ item.name }}</span>
                  <span class="size-count" v-if="item.count && isShowOptionFilterCount">({{item.count ? item.count : ''}})</span>
                </div>
              </label>
            </div>
            <div v-show="isShowMoreData[filter.alias]" class="customcheckbox" v-for="(item, newIndex6) in filter.showMoreData" :key="'filter' + newIndex6">
              <input type="checkbox" v-model="item.use" @change="applyFilters()">
              <label class="d-flex align-items-center label-wrapper">
                <span v-if="filter.field === 'colors' || filter.field === 'color'" class="color-icon-label" :style="{ backgroundColor: item.hex || item.slug }" :class="{'color-icon-border': item.slug === '#ffffff' || !item.slug}"></span>
                <div class="count-filter">
                  <span class="count-filter-label">{{item.name}}</span>
                  <span class="count-text" v-if="isShowOptionFilterCount">{{item.count ? item.count : ''}}</span>
                </div>
              </label>
            </div>
          </div>
          <div v-show="searchArraydData[filter.alias] !== ''">
            <div class="customcheckbox" v-for="(item, newIndex8) in filter.allProducts.filter(item => searchMatch(item, searchArraydData[filter.alias]))" :key="'filter' + filter.alias +newIndex8">
              <input type="checkbox" v-model="item.use" @change="applyFilters()">
              <label class="d-flex align-items-center label-wrapper">
                <span v-if="filter.field === 'colors' || filter.field === 'color'" class="color-icon-label" :style="{ backgroundColor: item.hex || item.slug }" :class="{'color-icon-border': item.slug === '#ffffff' || !item.slug}"></span>
                <div class="count-filter">
                  <span class="dark-text count-filter-label">{{item.name}}</span>
                  <span class="count-text" v-if="isShowOptionFilterCount">{{item.count ? item.count : ''}}</span>
                </div>
              </label>
            </div>
          </div>
          </div>
          <div v-if="filter.showMoreData.length !== 0 && searchArraydData[filter.alias] === ''" class="showMore" @click="showMoreBtnClick(filter)">{{ isShowMoreData && isShowMoreData[filter.alias] ? 'show less' : `+ ${filter.showMoreData.length} more`}}</div>
          <div class="dash-line"></div>
        </div>
        </div>
        <!-- Price filter Section -->
        <div
        :title="filter.alias"
        subtitle=""
        v-for="(filter, index3) in priceFilterOptionsData"
        :key="index3"
        :class="{
          'activewear-landing': (callerComp === 'activeWearLandingPage' || callerComp === 'winterWearLandingPage')
            ? 'supima-landing'
            : callerComp === 'supimaLandingPage',
        }"
        v-if="isShowStaticPlpPriceFilter && isSelectedCountryIndia"
      >
        <div class="headig-top">{{ filter.alias }}</div>
        <div class="maxer">
          <div v-if="filter.alias === 'Prices'" class="">
            <!-- Below Minimum Price -->
            <div class="customcheckbox radiobtn">
              <label class="d-flex align-items-center label-wrapper">
                <input
                  type="radio"
                  @change="applyPriceFilter(0, filter.priceRange[0][0])"
                  name="radiobtn"
                  :checked="value[1] === filter.priceRange[0][0] && value[0] === 0"
                />
                <span class="priceColor">Below {{ currencyRsToUSD }} {{ filter.priceRange[0][0] }}</span>
                <span class="price-count" v-if="isShowOptionFilterCount">{{ getPriceCountDesktop(null, filter.priceRange[0][0]) }}</span>
              </label>
            </div>

            <!-- Price Range Options -->
            <div
              class="customcheckbox radiobtn"
              v-for="(item, index7) in filter.priceRange"
              :key="'filter' + index7"
            >
              <label class="d-flex align-items-center label-wrapper">
                <input
                  type="radio"
                  @change="applyPriceFilter(item[0], item[1])"
                  name="radiobtn"
                  :checked="item[0] === value[0] && item[1] === value[1]"
                />
                <span class="priceColor">{{ currencyRsToUSD }} {{ item[0] }} - {{ currencyRsToUSD }} {{ item[1] }}</span>
                <span class="price-count" v-if="isShowOptionFilterCount">{{ getPriceCountDesktop(item[0], item[1]) }}</span>
              </label>
            </div>

            <!-- Above Maximum Price -->
            <div class="customcheckbox radiobtn">
              <label class="d-flex align-items-center label-wrapper">
                <input
                  type="radio"
                  @change="applyPriceFilter(filter.priceRange[filter.priceRange.length - 1][1], 100000)"
                  name="radiobtn"
                  :checked="value[0] === filter.priceRange[filter.priceRange.length - 1][1] && value[1] === 100000"
                />
                <span class="priceColor">Above {{ currencyRsToUSD }} {{ filter.priceRange[filter.priceRange.length - 1][1] }}</span>
                <span class="price-count" v-if="isShowOptionFilterCount">{{ getPriceCountDesktop(filter.priceRange[filter.priceRange.length - 1][1], null) }}</span>
              </label>
            </div>
          </div>
        </div>
        </div>

        <div :title="filter.alias" subtitle="" v-for="(filter, index3) in priceFilterOptionsData" :key="index3" :class="{'activewear-landing': (callerComp === 'activeWearLandingPage' || callerComp === 'winterWearLandingPage') ? 'supima-landing': callerComp === 'supimaLandingPage'}" v-if="(!isShowStaticPlpPriceFilter || !isSelectedCountryIndia)">
          <div class="headig-top">{{ filter.alias }}</div>
          <div class="maxer">
            <div v-if="filter.alias === 'Prices'" class="">
              <div class="customcheckbox radiobtn" v-for="(item, index7) in filter.priceRange" :key="'filter' + index7">
              <label class="d-flex align-items-center label-wrapper">
                <input type="radio" @change="applyPriceFilter(item[0], item[1])" name="radiobtn" :checked="(item[0] === value[0]) &&(item[1] === value[1])" >
                <span class="priceColor">{{ currencyRsToUSD }} {{ item[0] }} - {{ currencyRsToUSD }} {{ item[1] }}</span>
                <span class="price-count" v-if="isShowOptionFilterCount">{{ getPriceCountDesktop(item[0], item[1]) }}</span>
              </label>
            </div>
            </div>
          </div>
        </div>
        <!-- sneaker filter Section -->
        <div v-if="isShowSneakerFilter" :title="filter.alias" subtitle="" v-for="(filter, sneakerFilterOptionsDataIndex) in sneakerFilterOptionsData" :key="sneakerFilterOptionsDataIndex" :class="{'activewear-landing': (callerComp === 'activeWearLandingPage' || callerComp === 'winterWearLandingPage') ? 'supima-landing': callerComp === 'supimaLandingPage'}">
          <div class="headig-top">{{ filter.alias }}</div>
          <div class="maxer">
            <div v-if="filter.alias === 'Sneakers'" class="">
              <div class="customcheckbox radiobtn" v-for="(item, filterOptionIndex) in filter.options" :key="filterOptionIndex">
              <label class="d-flex align-items-center label-wrapper">
                <input type="radio" @click="applySneakerFilter(item)" name="radiobtn" :checked="item.slug === sneakerValue[0]" >
                <span class="priceColor">{{ item.name }}</span>
                <span class="price-count" v-if="isShowOptionFilterCount">{{ item.count ?  item.count : ''}}</span>
              </label>
            </div>
            </div>
          </div>
        </div>
         <!-- filter for themes -->
        <div :title="filter.alias" subtitle="" v-for="(filter, index) in otherFilterOptionsData" :key="index+'theme'" :class="{'activewear-landing': (callerComp === 'activeWearLandingPage' || callerComp === 'winterWearLandingPage') ? 'supima-landing': callerComp === 'supimaLandingPage'}">
          <div v-if="filter.alias === 'Themes'">
          <div class="headig-top">{{ filter.alias }}</div>
          <input type="text" class="form-control input-sm filter-search" v-model="filter.tr"
              v-if="filter.options.length > 5" :placeholder="`Search for ${filter.alias}`" @input="onSearchChange($event, filter)"/>
          <div class="maxer" :class="filter.alias === 'Size' ? 'd-flex flex-wrap size-filter' : ''">
            <div v-show="searchArraydData[filter.alias] === ''">
            <div class="customcheckbox" v-for="(item, newIndex) in filter.options" :key="'filter' + newIndex">
              <input type="checkbox" v-model="item.use" @change="applyFilters()">
              <label class="d-flex align-items-center label-wrapper">
                <span v-if="filter.field === 'colors' || filter.field === 'color'" class="color-icon-label" :style="{ backgroundColor: item.hex || item.slug }" :class="{'color-icon-border': item.slug === '#ffffff' || !item.slug}"></span>
                <div class="count-filter" v-if="filter.alias !== 'Size' "> 
                  <span class="count-filter-label">{{ item.name }}</span>
                  <span class="count-text" v-if="isShowOptionFilterCount">{{item.count ? item.count : ''}}</span>
                </div>
                <div v-else class="size-count-filter">
                  <span>{{ item.name }}</span>
                  <span class="size-count" v-if="item.count && isShowOptionFilterCount">({{item.count ? item.count : ''}})</span>
                </div>
              </label>
            </div>
            <div v-show="isShowMoreData[filter.alias]" class="customcheckbox" v-for="(item, newIndex6) in filter.showMoreData" :key="'filter' + newIndex6">
              <input type="checkbox" v-model="item.use" @change="applyFilters()">
              <label class="d-flex align-items-center label-wrapper">
                <span v-if="filter.field === 'colors' || filter.field === 'color'" class="color-icon-label" :style="{ backgroundColor: item.hex || item.slug }" :class="{'color-icon-border': item.slug === '#ffffff' || !item.slug}"></span>
                <div class="count-filter">
                  <span class="dark-text count-filter-label">{{item.name}}</span>
                  <span class="count-text" v-if="isShowOptionFilterCount">{{item.count ? item.count : ''}}</span>
                </div>
              </label>
            </div>
          </div>
          <div v-show="searchArraydData[filter.alias] !== ''">
            <div class="customcheckbox" v-for="(item, newIndex8) in filter.allProducts.filter(item => searchMatch(item, searchArraydData[filter.alias]))" :key="'filter' + filter.alias +newIndex8">
              <input type="checkbox" v-model="item.use" @change="applyFilters()">
              <label class="d-flex align-items-center label-wrapper">
                <span v-if="filter.field === 'colors' || filter.field === 'color'" class="color-icon-label" :style="{ backgroundColor: item.hex || item.slug }" :class="{'color-icon-border': item.slug === '#ffffff' || !item.slug}"></span>
                <div class="count-filter">
                  <span class="dark-text count-filter-label">{{item.name}}</span>
                  <span class="count-text" v-if="isShowOptionFilterCount">{{item.count ? item.count : ''}}</span>
                </div>
              </label>
            </div>
          </div>
          </div>
          <div v-if="filter.showMoreData.length !== 0 && searchArraydData[filter.alias] === ''" class="showMore" @click="showMoreBtnClick(filter)">{{ isShowMoreData && isShowMoreData[filter.alias] ? 'show less' : `+ ${filter.showMoreData.length} more`}}</div>
          <div class="dash-line"></div>
        </div>
        </div>
        <div class="row filterbtns showmobile">
          <div class="col-md-6 col-sm-6 col-6">
              <button type="button" class="btn btn-outline-primary btn-block" @click="applyFilters()">Apply</button>
          </div>
          <div class="col-md-6 col-sm-6 col-6">
              <button type="button" class="btn btn-outline-primary btn-block" @click="clearClick()">Clear</button>
          </div>
        </div>
      </div>
      <!-- filters mobile ui -->
      <div v-if="!$parent.$parent.isDesktop && isFilterVisible" class="filteroptionsModal" id="filter" :class="isFilterVisible ? 'filter-chart-wrapper' : ''">
        <div class="row p-3" style="border-bottom: 3px solid #f2f2f2;">
          <div class="col">
            <img class=" mb-1 mr-1" style="width:15px;height: 15px;" :data-src="staticImg + 'filterIcons/ic_filter.png'" alt="Filter"/>
            <span class="dark-text f16"><b>Filter</b></span>
          </div>
          <div class="col">
            <button style="text-decoration: underline;" class="f16 card-removeButton float-right" @click="clearClick()"> Clear All </button>
          </div>
        </div>
        <div class="filter-wrapper-mobile row">
          <div class="filter-catag col-4" style="padding-right: 0 !important;">
            <div class="col-12 p-3 filter-tab" :class="activeFilterTab === index4 ? 'active-filter-tab-class' : ''" @click="activeFilterTab = index4" v-for="(filter, index4) in otherFilterOptionsData" :key="index4" v-if="(!(webcategory === 'kids' && filter.alias === 'Size') || (filter.alias === 'Size' && isSelectedCountryIndia && enableVincenzeSearch && isKids))">
              <div class="filter-count-number">
              <span class="pl-3 dark-text"><b>{{filter.alias}}</b></span>
              <span class="all-filter-count" v-if="isShowAppliedFilterCount && filter.field === 'agegroup'">{{getFilterCountData(filter) > 0 ? getFilterCountData(filter) : '' }}</span>
              <span class="all-filter-count" v-else-if="isShowAppliedFilterCount">{{getFilterCountData(filter) > 0 ? getFilterCountData(filter) : '' }}</span>
              </div>
            </div>
            <div class="col-12 p-3 filter-tab" :class="activeFilterTab === otherFilterOptionsData.length ? 'active-filter-tab-class' : ''" @click="activeFilterTab = otherFilterOptionsData.length" v-for="(filter, index5) in priceFilterOptionsData" :key="index5">
              <span class="pl-3 dark-text"><b>{{filter.alias}}</b></span>
            </div>
          </div>
          <div class="filter-opt-area col">
            <div class="row">
              <div class="col-12" v-if="activeFilterTab !== otherFilterOptionsData.length">
                  <div class="maxer" style="overflow: hidden;" v-if="otherFilterOptionsData && otherFilterOptionsData[activeFilterTab] && (otherFilterOptionsData[activeFilterTab].alias ==='Gender' || otherFilterOptionsData[activeFilterTab].alias === 'Stock')">
                    <div class="customradio row p-3"
                      style="border-bottom:1px solid #f2f2f2;"
                      v-for="(item, index6) in otherFilterOptionsData && otherFilterOptionsData[activeFilterTab] && otherFilterOptionsData[activeFilterTab].options.filter(item => searchMatch(item,otherFilterOptionsData[activeFilterTab].tr))" :key="index6"
                      @click="handleRadioSelect(otherFilterOptionsData[activeFilterTab].field, item.slug)"
                    >
                      <div class="col text-initial dark-text">{{item.name}}</div>
                      <div class="col-1 mr-1">
                        <label style="margin-bottom: 0.18rem;">
                        <input type="radio"
                          :name="otherFilterOptionsData[activeFilterTab].field"
                          :value="item.slug"
                          v-model="selectedFiltersPrep[otherFilterOptionsData[activeFilterTab].field]"
                          :rel="item.name"
                        />
                        <span></span>
                      </label>
                      </div>
                    </div>
                  </div>
                  <div class="maxer" v-else>
                    <div class="customcheckbox col-12 p-3"
                      v-for="(item, index7) in otherFilterOptionsData && otherFilterOptionsData[activeFilterTab] && otherFilterOptionsData[activeFilterTab].options.filter(item => searchMatch(item,otherFilterOptionsData[activeFilterTab].tr))"
                      :key="index7"
                      style="border-bottom:1px solid #f2f2f2;"
                    >
                    <input type="checkbox" v-model="item.use">
                      <label class='d-flex align-items-center label-wrapper'>
                        <span v-if="otherFilterOptionsData && otherFilterOptionsData[activeFilterTab] && otherFilterOptionsData[activeFilterTab].alias === 'Colors'" class='color-icon-label' :style="{backgroundColor: item.hex || item.slug}" :class="{'color-icon-border': item.hex === '#ffffff' || !item.hex}"></span>
                        <div class="count-filter">
                          <span class="dark-text count-filter-label">{{item.name}}</span>
                          <span style=" padding-right:40px;" class="count-text" v-if="isShowOptionFilterCount">{{item.count ? item.count : ''}}</span>
                        </div>
                      </label>
                      
                    </div>
                  </div>
              </div>
              <div class="col-12" v-if="activeFilterTab === otherFilterOptionsData.length && isShowStaticPlpPriceFilter && isSelectedCountryIndia">          
                <div 
                  v-if="priceFilterOptionsData && priceFilterOptionsData[0] && priceFilterOptionsData[0].alias === 'Prices'"
                  class="maxer price-slider"
                  style="padding-top:1rem !important;"
                >
                  <div 
                    :title="filter.alias" 
                    subtitle="" 
                    v-for="(filter, index3) in priceFilterOptionsData" 
                    :key="index3" 
                    :class="{
                      'activewear-landing': 
                        (callerComp === 'activeWearLandingPage' || callerComp === 'winterWearLandingPage') 
                          ? 'supima-landing' 
                          : callerComp === 'supimaLandingPage'
                    }"
                  >
                    <div class="maxer">
                      <div v-if="filter.alias === 'Prices'" class="">
                        <!-- Below Minimum Price -->
                        <div class="customradio row py-3 justify-content-between" style="border-bottom:1px solid #f2f2f2;">
                          <span class="priceColor">Below {{ currencyRsToUSD }} {{ filter.priceRange[0][0] }}</span>
                          <span class="price-count" v-if="isShowOptionFilterCount">{{ getPriceCountDesktop(null, filter.priceRange[0][0]) }}</span>
                          <label class="ml-3">
                            <input 
                              type="radio" 
                              @change="applyPriceFilter(0, filter.priceRange[0][0])" 
                              name="radiobtn" 
                              :checked="value[0] === 0 && value[1] === filter.priceRange[0][0]"
                            >
                            <span class=""></span>
                          </label>
                        </div>

                        <!-- Price Range Options -->
                        <div 
                          class="customradio row py-3 justify-content-between" 
                          v-for="(item, index7) in filter.priceRange" 
                          :key="'filter' + index7" 
                          style="border-bottom:1px solid #f2f2f2;"
                        >
                          <span class="priceColor">{{ currencyRsToUSD }} {{ item[0] }} - {{ currencyRsToUSD }} {{ item[1] }}</span>
                          <span class="price-count" v-if="isShowOptionFilterCount">{{ getPriceCountDesktop(item[0], item[1]) }}</span>
                          <label class="ml-3">
                            <input 
                              type="radio" 
                              @change="applyPriceFilter(item[0], item[1])" 
                              name="radiobtn" 
                              :checked="(item[0] === value[0]) && (item[1] === value[1])"
                            >
                            <span class=""></span>
                          </label>
                        </div>

                        <!-- Above Maximum Price -->
                        <div class="customradio row py-3 justify-content-between" style="border-bottom:1px solid #f2f2f2;">
                          <span class="priceColor">Above {{ currencyRsToUSD }} {{ filter.priceRange[filter.priceRange.length - 1][1] }}</span>
                          <span class="price-count" v-if="isShowOptionFilterCount">{{ getPriceCountDesktop(filter.priceRange[filter.priceRange.length - 1][1], null) }}</span>
                          <label class="ml-3">
                            <input 
                              type="radio" 
                              @change="applyPriceFilter(filter.priceRange[filter.priceRange.length - 1][1], 100000)" 
                              name="radiobtn" 
                              :checked="value[0] === filter.priceRange[filter.priceRange.length - 1][1] && value[1] === 100000"
                            >
                            <span class=""></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12" v-if="activeFilterTab === otherFilterOptionsData.length && (!isShowStaticPlpPriceFilter || !isSelectedCountryIndia)">          
                <div v-if="priceFilterOptionsData && priceFilterOptionsData[0] && priceFilterOptionsData[0].alias === 'Prices'"
                  class="maxer price-slider"
                  style="padding-top:1rem !important;"
                >
                  <!-- <span class="dark-text font-weight-bold mb-5">₹ {{value[0]}} - ₹ {{value[1]}}</span>
                  <div class="mt-2 mb-4" v-if="isShowOptionFilterCount">
                    <span>{{ getPriceCount }}</span> products found.
                  </div>
                  <vue-slider
                    class="pt-4" 
                    ref="slider"
                    v-model="value"
                    v-bind="options">
                  </vue-slider> -->
                  <!--  -->
                  <div :title="filter.alias" subtitle="" v-for="(filter, index3) in priceFilterOptionsData" :key="index3" :class="{'activewear-landing': (callerComp === 'activeWearLandingPage' || callerComp === 'winterWearLandingPage') ? 'supima-landing': callerComp === 'supimaLandingPage'}">
                    <div class="maxer">
                      <div v-if="filter.alias === 'Prices'" class="">
                        <div class="customradio row py-3 justify-content-between" v-for="(item, index7) in filter.priceRange" :key="'filter' + index7" style="border-bottom:1px solid #f2f2f2;">
                        <span class="priceColor">{{ currencyRsToUSD }} {{ item[0] }} - {{ currencyRsToUSD }} {{ item[1] }}</span>
                        <span class="price-count" v-if="isShowOptionFilterCount">{{ getPriceCountDesktop(item[0], item[1]) }}</span>
                        <label class="ml-3">
                          <input type="radio" @change="applyPriceFilter(item[0], item[1])" name="radiobtn" :checked="(item[0] === value[0]) &&(item[1] === value[1])" >
                          <span class=""></span>
                        </label>
                      </div>
                    </div>
                    </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Sorts-->
      <div class="filteroptionsModal" id="sort" :style="!$parent.$parent.isDesktop ? 'background: transparent;' : ''">
        <!-- sort mobile UI  -->
        <div style="overflow-x: hidden;" v-if="!$parent.$parent.isDesktop">
          <div class="closeBtn col-12" @click="toggleFilter('sort')">
            <span class="float-right" >
              <svg xmlns="http://www.w3.org/2000/svg" id="CloseIcon" width="24" height="24" viewBox="0 0 24 24">
                <path id="Line_9" d="M12 0L0 12" class="cls-1" transform="translate(6 6)"/>
                <path id="Line_10" d="M0 0L12 12" class="cls-1" transform="translate(6 6)"/>
              </svg>
            </span>
          </div>
          <div class="col-12 pt-2 pb-3" style="background: #fff;border-top-right-radius: 8px;border-top-left-radius: 8px;">
            <img class=" ml-3 mb-1 mr-1" style="width:19px;height: 13px;" :data-src="staticImg + 'filterIcons/ic_sort.png'" alt="Sort"/>
            <span class="dark-text f16 pl-2 text-stroke"><b>Sort</b></span>
          </div>
          <div class="row justify-content-end pt-1 pb-1 px-3"
            style="background: #fff;"
            v-for="(item, index8) in sorts"
            :key="index8"
            :style="index8 < (sorts.length -1) ? 'border-bottom: 1px solid #f2f2f2;': ''"
          >
            <div class="col pt-1" @click="sortMobileHandler(item)">
              <span class="ml-2 dark-text">{{item.name}}</span>
            </div>
            <div class="col-1 mr-2 pt-1" @click="sortMobileHandler(item)">
              <label>
                <input type="radio" name="sort"
                  :value="item.value"
                  v-model="selectedFilters.sort"
                  :rel="item.name"
                />
                <span></span>
              </label>
            </div>
          </div>
        </div>
        <!-- <expander title="sort" noMaxHeight="true" v-if="$parent.$parent.isDesktop" :class="{'activewear-landing': callerComp === 'activeWearLandingPage' ? 'supima-landing': callerComp === 'supimaLandingPage'}">
          <div class="customradio" v-for="(item, index) in sorts" :key=item.value>
              <label>
                <input type="radio"
                  name="sort"
                  :value="item.value"
                  v-model="selectedFilters.sort"
                  :rel="item.name"
                />
                <span></span>
              </label>
              <span>{{item.name}}</span>
          </div>
        </expander> -->
        <!--
        <div class="row filterbtns showmobile">
          <div class="col-md-6 col-sm-6 col-6">
              <button type="button" class="btn btn-outline-primary btn-block" @click="applyFilters()">Apply</button>
          </div>
          <div class="col-md-6 col-sm-6 col-6">
              <button type="button" class="btn btn-outline-primary btn-block" @click="clearClick()">Clear</button>
          </div>
        </div>
       -->
      </div>
      <!-- Age Group mobile UI -->
      <div class="filteroptionsModal" id="age" :style="!$parent.$parent.isDesktop ? 'background: transparent;' : ''">
        <div style="overflow-x: hidden;" v-if="!$parent.$parent.isDesktop && isShowAgeModal">
          <div class="closeBtn col-12" @click="toggleFilter('age')">
            <span class="float-right" >
              <svg xmlns="http://www.w3.org/2000/svg" id="CloseIcon" width="24" height="24" viewBox="0 0 24 24">
                <path id="Line_9" d="M12 0L0 12" class="cls-1" transform="translate(6 6)"/>
                <path id="Line_10" d="M0 0L12 12" class="cls-1" transform="translate(6 6)"/>
              </svg>
            </span>
          </div>
          <div class="col-12 pt-2 pb-3" style="background: #fff;border-top-right-radius: 8px;border-top-left-radius: 8px;">
            <!-- <img class=" ml-3 mb-1 mr-1" style="width:19px;height: 13px;" :data-src="staticImg + 'filterIcons/ic_sort.png'" alt="Sort"/> -->
            <span class="dark-text f16 pl-2 text-stroke"><b>Age Group</b></span>
          </div>
          <div class="row justify-content-end pt-1 pb-1 px-3"
            style="background: #fff;"
            v-for="(item, ageGroupsIndex) in ageGroups"
            :key="ageGroupsIndex"
            :style="ageGroupsIndex < (ageGroups.length -1) ? 'border-bottom: 1px solid #f2f2f2;': ''"
          >
            <div class="col pt-2" @click="applyFilters()">
              <span class="ml-2 dark-text">{{item.name}}</span>
            </div>
            <div class="col-1 customcheckbox" @click="">
              <input type="checkbox" v-model="item.use" @change="applyFilters()">
              <label class="mt-1" style="padding: 1rem !important;">
                <span></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row filterbtns showdesktop">
      <div class="col-md-6 col-sm-6 col-6">
          <button type="button" class="btn btn-outline-primary btn-block" @click="applyFilters()">Apply</button>
      </div>
      <div class="col-md-6 col-sm-6 col-6">
          <button type="button" class="btn btn-outline-primary btn-block" @click="clearClick()">Clear</button>
      </div>
    </div> -->
  </div>
</template>

<script>
  import Expander from './vue-accordian.vue'
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/default.css'
  import SideNav from '../../sideNav.vue'
  import Vue from 'vue'
  var $ = require('jquery')
  window.jQuery = $
  import {mapGetters} from 'vuex'

  export default {
    components: {Expander, VueSlider, SideNav},
    name: 'filter-options',
    data () {
      return {
        sorts: [],
        ageGroups: [],
        sneakerOptions: [],
        sneakerValue: [],
        filters: {
          options: []
        },
        prices: [],
        value: [],
        selectedFilters: {sort: 'DEFAULT', gender: 0, stock: ''},
        autoSelectAge: false,
        selectedFiltersPrep: {},
        backup: {},
        options: {
          dotSize: 14,
          width: 'auto',
          height: 4,
          contained: false,
          direction: 'ltr',
          data: null,
          dataLabel: 'label',
          dataValue: 'value',
          min: 0,
          max: 100,
          interval: 1,
          disabled: false,
          clickable: true,
          duration: 0.5,
          adsorb: false,
          lazy: false,
          tooltip: 'active',
          tooltipPlacement: 'top',
          tooltipFormatter: void 0,
          useKeyboard: false,
          keydownHook: null,
          dragOnClick: false,
          enableCross: true,
          fixed: false,
          minRange: void 0,
          maxRange: void 0,
          order: true,
          marks: false,
          dotOptions: [{
            tooltip: this.$parent.$parent.isDesktop ? 'always' : 'none'
          }, {
            tooltip: this.$parent.$parent.isDesktop ? 'always' : 'none'
          }],
          dotAttrs: void 0,
          process: dotsPos => [
            [dotsPos[0], dotsPos[1], { backgroundColor: '#117a7a' }]
          ],
          dotStyle: void 0,
          railStyle: void 0,
          processStyle: void 0,
          tooltipStyle: {
            backgroundColor: '#117a7a',
            borderColor: '#117a7a'
          },
          stepStyle: void 0,
          stepActiveStyle: void 0,
          labelStyle: void 0,
          labelActiveStyle: void 0
        },
        bgStyle: {
          backgroundColor: '#fff',
          boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
        },
        tooltipStyle: {
          backgroundColor: '#666',
          borderColor: '#666'
        },
        processStyle: {
          backgroundColor: '#999'
        },
        staticImg: process.env.STATIC_IMG_SERVER2,
        activeFilterTab: 0,
        mobileFilterVisible: true,
        isFilterVisible: false,
        selectedSortObj: {},
        isShowMoreData: {},
        priceArray: [],
        searchArraydData: {},
        showSideNav: false
      }
    },
    props: ['toggleScrollToUpVisible', 'callerComp', 'isKids'],
    computed: {
      ...mapGetters({category: 'category', artist: 'artist', _filters: '_filters', products: 'FETCH_PRODUCTS', isExclusive: 'isExclusive', bannerPlcaeHolderData: 'bannerPlcaeHolderData', currencyRsToUSD: 'currencyRsToUSD', overlayFreeze: 'overlayFreeze', currencySymbol: 'currencySymbol', webcategory: 'webcategory', navigatedFromAgeGroup: 'navigatedFromAgeGroup', user: 'user', authStatus: 'authStatus', isSelectedCountryIndia: 'isSelectedCountryIndia', globalBannerPlaceholder: 'globalBannerPlaceholder'}),
      'gqlQuery': function () {
        return this.$store.getters.gqlQuery
      },
      otherFilterOptionsData () {
        let metaPayload = ''
        if (this.$route.params.type) {
          metaPayload = {type: this.$route.params.type}
        } else {
          metaPayload = {type: 'tags'}
        }
        if (!this.$parent.$parent.isDesktop && (metaPayload.type === 'tags' || metaPayload.type === 'artists')) {
          return this.filters && this.filters.options && this.filters.options.length && this.filters.options.filter((filtr) => filtr.alias !== 'sort' && filtr.alias !== 'Gender' && filtr.alias !== 'Prices' && filtr.alias !== 'Sneakers' && filtr.options && filtr.options.length > 0)
        }
        if (metaPayload.type === 'men' || metaPayload.type === 'women' || metaPayload.type === 'kids') {
          if (this.$parent.$parent.isDesktop) {
            let filterOptionData = this.filters && this.filters.options && this.filters.options.length && this.filters.options.filter((filtr) => filtr.alias !== 'sort' && filtr.alias !== 'Gender' && filtr.alias !== 'Prices' && filtr.alias !== 'Sneakers' && filtr.options && filtr.options.length > 0)
            return this.getFilterItemData(filterOptionData)
          }
          return this.filters && this.filters.options && this.filters.options.length && this.filters.options.filter((filtr) => filtr.alias !== 'sort' && filtr.alias !== 'Gender' && filtr.alias !== 'Prices' && filtr.alias !== 'Sneakers' && filtr.options && filtr.options.length > 0)
        }
        if (this.$parent.$parent.isDesktop) {
          let filterOptionData = this.filters && this.filters.options && this.filters.options.length && this.filters.options.filter((filtr) => filtr.alias !== 'sort' && filtr.alias !== 'Prices' && filtr.alias !== 'Sneakers' && filtr.options && filtr.options.length > 0)
          return this.getFilterItemData(filterOptionData)
        }
        return this.filters && this.filters.options && this.filters.options.length && this.filters.options.filter((filtr) => filtr.alias !== 'sort' && filtr.alias !== 'Prices' && filtr.alias !== 'Sneakers' && filtr.options && filtr.options.length > 0)
      },
      priceFilterOptionsData () {
        let filterPriceData = this.filters && this.filters.options && this.filters.options.length && this.filters.options.filter((filtr) => filtr.alias === 'Prices' && filtr.options && filtr.options.length > 0)
        if (this.$parent.$parent.isDesktop) {
          return this.getPriceFilterData(filterPriceData)
        }
        return this.getPriceFilterData(filterPriceData)
      },
      sneakerFilterOptionsData () {
        let filterPriceData = this.filters && this.filters.options && this.filters.options.length && this.filters.options.filter((filtr) => filtr.alias === 'Sneakers' && filtr.options && filtr.options.length > 0)
        return filterPriceData
      },
      enableVincenzeSearch: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Search Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_VINCENZE_SEARCH'.toLowerCase())
      },
      isFilterApplied () {
        let output = []
        let checkObj = {}
        Object.assign(checkObj, this.selectedFilters)
        checkObj && checkObj.gender === 0 ? delete checkObj.gender : ''
        checkObj && checkObj.stock === '' ? delete checkObj.stock : ''
        // checkObj && checkObj.agegroup === '' ? delete checkObj.agegroup : ''
        output = this.otherFilterOptionsData.filter(ftr => {
          return ftr.field in checkObj
        })
        this.selectedFilters && this.selectedFilters.price && (parseInt(this.selectedFilters.price[0]) !== parseInt(this.options.min) || parseInt(this.selectedFilters.price[1]) !== parseInt(this.options.max)) ? output.push({field: 'price'}) : ''
        return output && output.length
      },
      isAgeGroupFilterApplied () {
        let checkObj = {}
        Object.assign(checkObj, this.selectedFilters)
        return checkObj && checkObj.agegroup
      },
      getSelectedFilterChips () {
        let filterChips = []
        if (this.selectedFilters && Object.keys(this.selectedFilters).length) {
          this.filters && this.filters.options && this.filters.options.filter((item) => {
            if (item.field in this.selectedFilters) {
              if (item.alias !== 'Prices') {
                item.options.filter((opt) => {
                  if (Array.isArray(this.selectedFilters[item.field]) && this.selectedFilters[item.field].indexOf(opt.slug) !== -1) {
                    opt.alias = item.alias
                    opt.field = item.field
                    filterChips.push(opt)
                  }
                })
              } else {
                if (this.selectedFilters && this.selectedFilters.price && (this.selectedFilters.price[0].toString() !== this.prices[0].toString() || this.selectedFilters.price[1].toString() !== this.prices[1].toString())) {
                  // filterChips.push({name: `${this.currencyRsToUSD} ${this.selectedFilters.price[0]} - ${this.currencyRsToUSD} ${this.selectedFilters.price[1]}`, alias: item.alias, field: item.field})
                  if (this.selectedFilters.price[0].toString() === '0' && this.isShowStaticPlpPriceFilter && this.isSelectedCountryIndia) {
                    // Below minimum price chip
                    filterChips.push({
                      name: `Below ${this.currencyRsToUSD} ${this.selectedFilters.price[1]}`,
                      alias: item.alias,
                      field: item.field
                    })
                  } else if (this.selectedFilters.price[1].toString() === '100000' && this.isShowStaticPlpPriceFilter && this.isSelectedCountryIndia) {
                    // Above maximum price chip
                    filterChips.push({
                      name: `Above ${this.currencyRsToUSD} ${this.selectedFilters.price[0]}`,
                      alias: item.alias,
                      field: item.field
                    })
                  } else {
                    // Normal price range chip
                    filterChips.push({
                      name: `${this.currencyRsToUSD} ${this.selectedFilters.price[0]} - ${this.currencyRsToUSD} ${this.selectedFilters.price[1]}`,
                      alias: item.alias,
                      field: item.field
                    })
                  }
                }
              }
            }
          })
          // if ('agegroup' in this.selectedSortObj || 'agegroup' in this.selectedFilters) {
          //   'agegroup' in this.selectedSortObj ? '' : this.selectedSortObj = this.selectedFilters
          //   this.sorts && this.sorts.filter((srt) => {
          //     if (srt.value === this.selectedSortObj['agegroup']) {
          //       filterChips.push({name: srt.name, alias: 'Age Group', field: 'agegroup'})
          //       this.$emit('updateSortingOptions', {name: srt.name, alias: 'Age Group', field: 'agegroup'})
          //     }
          //   })
          // }
          if ('sort' in this.selectedSortObj || 'sort' in this.selectedFilters) {
            'sort' in this.selectedSortObj ? '' : this.selectedSortObj = this.selectedFilters
            this.sorts && this.sorts.filter((srt) => {
              if (srt.value === this.selectedSortObj['sort']) {
                filterChips.push({name: srt.name, alias: 'Sort', field: 'sort'})
                this.$emit('updateSortingOptions', {name: srt.name, alias: 'Sort', field: 'sort'})
                this.$store.commit('MOENGAGE_CUSTOM_ATTRIBUTES', {attName: 'SORT_PLP', payload: srt.name})
              }
            })
          }
        }
        return filterChips
      },
      isShowOptionFilterCount: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_FILTER_OPTIONS_COUNT_WEB'.toLowerCase())
      },
      isShowAppliedFilterCount: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_APPLIED_FILTER_COUNT_WEB'.toLowerCase())
      },
      isShowSneakerFilter: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_SNEAKER_FILTER_WEB'.toLowerCase())
      },
      isShowStaticPlpPriceFilter: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_STATIC_PRICE_FILTER_PLP'.toLowerCase())
      },
      isShowAutoGenderSwitch: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_GENDER_PLP_SEARCH_SWITCH'.toLowerCase())
      },
      isShowAutoSelectedGenderSwitch: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_AUTO_GENDER_FILTER_PLP'.toLowerCase())
      },
      isAutoAppliedFilter: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'AUTO_FILTER_APPLIED_PLP_WEB'.toLowerCase())
      },
      isShowAgeModal: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_AGE_FILTER_PLP_WEB'.toLowerCase())
      },
      getPriceCount () {
        const [startPrice, endPrice] = this.value
        const filteredData = this.priceFilterOptionsData[0].options.filter(item => {
          const slugValue = parseFloat(item.slug)
          return slugValue >= startPrice && slugValue <= endPrice
        })
        const totalCount = filteredData.reduce((acc, item) => acc + item.count, 0)
        return totalCount || ''
      },
      showHamburgerMenuIcon: function () {
        return this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData => bannerData.is_active === true && bannerData.config_key === 'SHOW_LISTING_HAMBURGER_WEB')
      }
    },
    watch: {
      isFilterVisible (isVisible) {
        if (!this.$parent.$parent.isDesktop && isVisible && this.toggleScrollToUpVisible) {
          this.toggleScrollToUpVisible(false)
        }
      },
      overlayFreeze (newval) {
        if (newval && $('#sort').hasClass('active')) {
          this.toggleFilter('sort')
          $('.page-overlay').toggleClass('show')
        }
      },
      otherFilterOptionsData (val) {
        if (val.length && this.autoSelectAge && this.navigatedFromAgeGroup && this.navigatedFromAgeGroup.length && this.isAutoAppliedFilter) {
          let item = this.navigatedFromAgeGroup[0] + ',' + this.navigatedFromAgeGroup[1]
          let age = val.find(obj => obj.field === 'agegroup')
          age.options.forEach(obj => {
            if (obj.slug === item) {
              obj.use = true
              this.applyFilters()
              this.autoSelectAge = false
            }
          })
        }
      },
      navigatedFromAgeGroup (data, newData) {
        let old = data[0] + ',' + data[1]
        let newg = newData[0] + ',' + newData[1]
        if (old !== newg) {
          this.autoSelectAge = true
        }
      }
    },
    methods: {
      decodeFilters (filters) {
        let parsedObj = {}
        for (let row of filters.split('|||')) {
          let d = row.split('||')
          if (d[0] === 'sort' || d[0] === 'gender' || d[0] === 'stock') {
            parsedObj[d[0]] = d[1]
          } else {
            parsedObj[d[0]] = d[1].split('|')
          }
        }
        return parsedObj
      },
      setGenderFromCache () {
        const gender = Vue.ls.get('tss_landingCategory')
        // Ensure gender is selected based on cached values
        const filtersParam = this.$route.query && this.$route.query.filters
        const parsedFilters = filtersParam && this.decodeFilters(filtersParam)
        const queryGender = parsedFilters && parsedFilters.gender
        Vue.nextTick(() => {
          if (queryGender) {
            this.selectedFilters['gender'] = queryGender
            return
          }
          if (gender === 'men') {
            this.selectedFilters['gender'] = 1
          } else if (gender === 'women') {
            this.selectedFilters['gender'] = 2
          } else if (gender === 'kids') {
            this.selectedFilters['gender'] = 3
          }
          this.$forceUpdate()
        })
      },
      getFilterCountData (filter) {
        if (filter && filter.field && this.selectedFilters[filter.field]) {
          return this.selectedFilters[filter.field].length
        } else {
          return 0
        }
      },
      getPriceCountDesktop (startPrice, endPrice) {
        const filteredData = this.priceFilterOptionsData[0].options.filter(item => {
          const slugValue = parseFloat(item.slug)
          return slugValue >= startPrice && slugValue <= endPrice
        })
        const totalCount = filteredData.reduce((acc, item) => acc + item.count, 0)
        return totalCount || ''
      },
      onSearchChange (e, filter) {
        this.searchArraydData[filter.alias] = e.target.value
        this.$forceUpdate()
      },
      uncheckPriceRadioButtons () {
        var priceRadioBtnEle = document.getElementsByName('radiobtn')
        for (let i = 0; i < priceRadioBtnEle.length; i++) {
          priceRadioBtnEle[i].checked = false
        }
      },
      handleScroll () {
        const filtersContainer = this.$refs.filtersContainer
        if (filtersContainer) {
          const scrollPosition = window.scrollY
          let filtersHeight = filtersContainer.clientHeight
          const productsHeight = this.$el.querySelector('.filtersection').clientHeight
          const filtersEnd = productsHeight - filtersHeight
          if (scrollPosition > filtersHeight) {
            filtersHeight = scrollPosition
          }
          if (scrollPosition < filtersEnd) {
            filtersContainer.style.transform = `translateY(${scrollPosition}px)`
          } else {
            filtersContainer.style.transform = `translateY(${filtersEnd}px)`
          }
        }
      },
      showMoreBtnClick (filter) {
        this.isShowMoreData[filter.alias] = !this.isShowMoreData[filter.alias]
        this.$forceUpdate()
      },
      getFilterItemData (filterOptionData) {
        let filterItemsData = []
        filterOptionData && filterOptionData.map((item, index) => {
          var showMoreOption = false
          var options = item && item.options
          var showMoreData = []
          var allProducts = item.options
          if (item.options.length > 10) {
            showMoreOption = true
            options = item.options.slice(0, 10)
            showMoreData = item.options.slice(10)
          }
          if (item && item.alias === 'Gender') {
            filterItemsData.unshift({
              alias: item.alias,
              showMoreOption,
              options,
              showMoreData,
              allProducts,
              tr: item.tr,
              field: item.field
            })
          } else {
            filterItemsData.push({
              alias: item.alias,
              showMoreOption,
              options,
              showMoreData,
              allProducts,
              tr: item.tr,
              field: item.field
            })
          }
          this.isShowMoreData[item.alias] = false
          this.searchArraydData[item.alias] = ''
        })
        return filterItemsData
      },
      getPriceFilterData (priceFilterData) {
        if (priceFilterData) {
          let priceData = priceFilterData[0] && priceFilterData[0].options
          let priceArr = []
          priceData && priceData.map((item) => { priceArr.push(Number(item.name)) })
          const [minPrice, maxPrice] = this.findMinMax(priceArr)
          let diffPrice = maxPrice - minPrice
          let priceRange = this.createRanges(minPrice, maxPrice, 1)
          if (diffPrice <= 500) {
            priceRange = this.createRanges(minPrice, maxPrice, 2)
          } else if (diffPrice > 500 && diffPrice <= 1200) {
            priceRange = this.createRanges(minPrice, maxPrice, 3)
          } else if (diffPrice > 1200 && diffPrice <= 2000) {
            priceRange = this.createRanges(minPrice, maxPrice, 4)
          } else {
            priceRange = this.createRanges(minPrice, maxPrice, 6)
          }
          if (priceFilterData.length > 0) {
            priceFilterData[0].priceRange = priceRange
          }
          return priceFilterData
        }
      },
      findMinMax (arr) {
        if (!arr || arr.length === 0) {
          return [undefined, undefined]
        }
        let minVal = arr[0]
        let maxVal = arr[0]
        for (let i = 1; i < arr.length; i++) {
          if (arr[i] < minVal) {
            minVal = arr[i]
          }
          if (arr[i] > maxVal) {
            maxVal = arr[i]
          }
        }
        return [minVal, maxVal]
      },
      createRanges (a, b, numRanges) {
        if (this.isShowStaticPlpPriceFilter && this.isSelectedCountryIndia) {
          const ranges = [
            [299, 499],
            [499, 699],
            [699, 999]
          ]
          return ranges
        } else {
          const ranges = []
          if (b < a || numRanges <= 0) {
            return ranges // Return an empty array if invalid input or no ranges needed
          }
          const step = Math.floor((b - a + 1) / numRanges) // Calculate the step size
  
          for (let i = 0; i < numRanges; i++) {
            const start = a + i * step
            const end = i === numRanges - 1 ? b : start + step - 1
            ranges.push([start, end])
          }
  
          return ranges
        }
      },
      applyPriceFilter (minPrice, maxPrice) {
        this.value = [minPrice, maxPrice]
        if (this.$parent.$parent.isDesktop) {
          this.applyFilters()
        }
      },
      applySneakerFilter (option) {
        this.sneakerValue = [option.slug]
        this.$parent.sneakerdata = this.sneakerValue
        this.applyFilters()
      },
      applyFilters () {
        this.selectedFilters = this.makeFilters()
        this.selectedSortObj = {...this.selectedFilters}
        if (!this.$parent.$parent.isDesktop) {
          if (Object.keys(this.selectedFiltersPrep) && Object.keys(this.selectedFiltersPrep).length) {
            for (let k in this.selectedFiltersPrep) this.selectedFilters[k] = this.selectedFiltersPrep[k]
          } else {
            delete this.selectedFilters.gender
            delete this.selectedFilters.stock
            // delete this.selectedFilters.agegroup
          }
          this.selectedFilters && this.selectedFilters.price && (parseInt(this.selectedFilters.price[0]) !== parseInt(this.options.min) || parseInt(this.selectedFilters.price[1]) !== parseInt(this.options.max)) ? '' : delete this.selectedFilters.price
        }
        this.$emit('filterClick')
        const routeObj = Vue.ls.get('routeObj')
        this.$store.commit('MOENGAGE_EVENT', {eventName: 'APPLY_FILTER_PLP',
          payload: {
            color: this.selectedFilters.color,
            size: this.selectedFilters.size,
            gender: this.selectedFilters.gender,
            discount: this.selectedFilters.discount,
            price: this.selectedFilters.price,
            theme: this.selectedFilters.artist,
            products: this.selectedFilters.category,
            fabric: this.selectedFilters.fabric,
            sorting: this.selectedFilters.sort,
            pattern: this.selectedFilters.pattern,
            sleeve: this.selectedFilters.sleeve,
            neck: this.selectedFilters.neck,
            fittype: this.selectedFilters.fittype,
            ageGroup: this.selectedFilters.agegroup || 'NA',
            'Filter by size': this.selectedFilters && this.selectedFilters.size && this.selectedFilters.size.length && this.selectedFilters.size.join(','),
            'Filter by prices': this.selectedFilters && this.selectedFilters.price && this.selectedFilters.price.length && this.selectedFilters.price.join(','),
            'Filter by themes': this.selectedFilters && this.selectedFilters.artist && this.selectedFilters.artist.length && this.selectedFilters.artist.join(','),
            'Filter by products': this.selectedFilters && this.selectedFilters.category && this.selectedFilters.category.length && this.selectedFilters.category.join(','),
            'Filter by Genres': this.selectedFilters && this.selectedFilters.tags && this.selectedFilters.tags.length && this.selectedFilters.tags.join(','),
            Page_Name: routeObj.current === 'Search Page' ? 'Search PLP Page' : routeObj.current
          }
        })
        this.closeFilterModal()
      },
      clearClick () {
        this.$store.dispatch('TATVIC_EVENT', {eventName: 'FILTER_CLEAR_ALL', payload: {LIST_NAME: this.$parent.formattedHeader || ''}})
        this.filters.options && this.filters.options.forEach((value, key) => {
          value.options.map(item => {
            delete item.use
          })
        })
        !this.$parent.$parent.isDesktop ? '' : this.$emit('clearClick')
        $('.filteroptionsModal').find('.customcheckbox').find('input').attr('checked', false)
        Array.from($('.filteroptionsModal').find('.customcheckbox').find('input')) && Array.from($('.filteroptionsModal').find('.customcheckbox').find('input')).forEach(itm => {
          itm.checked = false
        })
        this.selectedFiltersPrep = {}
        this.selectedSortObj = {}
        this.value = this.prices
      },
      closeFilterModal () {
        $('.filteroptionsModal').removeClass('active')
        $('.plisting').removeClass('disable')
        $('.filteroption').removeClass('active')
        $('.btn').removeClass('active')
        $('.page-overlay').removeClass('show')
        this.isFilterVisible = false
        $('.navbar')[0].style.display = ''
        document.body.classList.remove('noscroll')
        const self = this
        setTimeout(function () {
          self.mobileFilterVisible = true
        }, 250)
      },
      makeFilters () {
        let filterObj = {}
        if (this.selectedFilters && this.selectedFilters.sort) {
          filterObj.sort = this.selectedFilters.sort
        }
        for (let item of this.filters.options) {
          let options = item.options.filter(item => item.use).map(item => item.slug)
          if (options.length) {
            if (item.field !== 'gender' && item.field !== 'stock') {
              filterObj[item.field] = options
            }
          }
        }
        if (this.value && this.value.length) {
          filterObj.price = this.value
        }
        if (this.sneakerValue && this.sneakerValue.length) {
          filterObj.sneaker = this.sneakerValue
        } else if (this.$parent.sneakerdata && this.$parent.sneakerdata.length) {
          filterObj.sneaker = this.$parent.sneakerdata
        } else {
          delete filterObj.sneaker
        }
        if ((this.selectedFilters && this.selectedFilters.gender) || (this.selectedFiltersPrep && this.selectedFiltersPrep.gender)) {
          filterObj.gender = !this.$parent.$parent.isDesktop ? this.selectedFiltersPrep && this.selectedFiltersPrep.gender : this.selectedFilters.gender
        }
        if (this.selectedFilters && this.selectedFilters.stock && (this.selectedFilters.stock === '0' || this.selectedFilters.stock === '1')) {
          filterObj.stock = !this.$parent.$parent.isDesktop ? this.selectedFiltersPrep && this.selectedFiltersPrep.stock : this.selectedFilters.stock
        }
        return filterObj
      },
      searchMatch (item, str) {
        // This will replace thesort: 'POPULARITY' TM value to a blank thing
        item.name = item.name && item.name.replace('\u0099', '')
        return !str || item.name.toLowerCase().match(str.toLowerCase())
      },
      setFilters (filterData, appliedFilters) {
        this.backup = JSON.parse(JSON.stringify(filterData))
        let fdata = JSON.parse(JSON.stringify(filterData))
        const sortsData = fdata.filter((e) => {
          return e.field === 'Sort'
        })
        const sortDataOptions = sortsData && sortsData.length && sortsData[0] && sortsData[0].options
        if (sortDataOptions && sortDataOptions.length) {
          this.sorts = sortDataOptions.map((obj) => {
            obj.value = obj.slug
            return obj
          })
        }
        const ageGroupData = fdata.filter((e) => {
          return e.field === 'agegroup'
        })
        const ageGroupDataOptions = ageGroupData && ageGroupData.length && ageGroupData[0] && ageGroupData[0].options
        if (ageGroupDataOptions && ageGroupDataOptions.length) {
          this.ageGroups = ageGroupDataOptions.map((obj) => {
            obj.value = obj.slug
            return obj
          })
        }
        fdata = fdata.filter(function (e) { return !['tags', 'Sort'].includes(e.field) })
        for (let item of fdata) {
          item.tr = ''
          if (!appliedFilters) {
            continue
          }
          let filters = appliedFilters[item.field]
          if (appliedFilters[item.field]) {
            for (let option of item.options) {
              if (filters && filters.includes(option.slug)) {
                option.use = true
              }
            }
          }
        }
        this.selectedFilters.sort = appliedFilters.sort || ''
        this.selectedFilters.gender = appliedFilters.gender || 0
        this.selectedFilters.stock = appliedFilters.stock || ''
        // this.selectedFilters.agegroup = appliedFilters.agegroup || []
        this.sneakerValue = appliedFilters.sneaker && appliedFilters.sneaker || []
        this.$parent.sneakerdata = this.sneakerValue
        this.filters.options = fdata
        if (this.isShowAutoSelectedGenderSwitch) {
          this.setGenderFromCache()
        }
        appliedFilters && Object.keys(appliedFilters).length ? this.selectedFilters = appliedFilters : ''
        // get price filter data
        let priceFilterArr = this.filters && this.filters.options && this.filters.options.length && this.filters.options.filter(item => item.alias === 'Prices')[0]
        let priceArrVal = priceFilterArr && priceFilterArr.options.map(item => parseInt(item.name))
        this.prices = priceArrVal && [Math.min(...priceArrVal), Math.max(...priceArrVal)]
        // get filter for price if appliedFilters for price exist
        if (appliedFilters && appliedFilters.price && appliedFilters.price.length) {
          this.value = appliedFilters.price.map(price => parseInt(price))
          this.options.min = this.value[0] >= this.prices[0] ? this.prices[0] : this.value[0]
          this.options.max = this.value[1] >= this.prices[1] ? this.value[1] : this.prices[1]
          return
        }
        // when no appliedFilters for price exist
        this.options.min = this.prices && this.prices[0]
        this.options.max = this.prices && this.prices[1]
        this.value = this.prices
        this.sneakerValue = []
      },
      toggleFilter (opt) {
        if ($('#' + opt).hasClass('active')) {
          $('#' + opt).toggleClass('active')
          $('.' + opt).toggleClass('active')
          $('.filteroption').toggleClass('active')
          $('.plisting').toggleClass('disable')
          $('.page-overlay').toggleClass('show')
          this.mobileFilterVisible = true
          opt === 'filter' ? $('.navbar')[0].style.display = '' : ''
          opt === 'filter' ? this.isFilterVisible = false : ''
          document.body.classList.remove('noscroll')
          this.$store.commit('SET_OVERLAY_FREEZE', false)
        } else {
          $('.filteroptionsModal').removeClass('active')
          $('.btn').removeClass('active')
          $('#' + opt).addClass('active')
          $('.' + opt).addClass('active')
          $('.filteroption').addClass('active')
          $('.plisting').addClass('disable')
          $('.page-overlay').addClass('show')
          this.$store.commit('SET_OVERLAY_FREEZE', false)
          this.mobileFilterVisible = false
          opt === 'filter' ? $('.navbar')[0].style.display = 'none' : ''
          opt === 'filter' ? this.isFilterVisible = true : ''
          this.otherFilterOptionsData && this.otherFilterOptionsData.forEach((value, key) => {
            let categoryPreventWipe = 0
            value.options.map(item => {
              const result = this.getSelectedFieldCheck(value.field, item.slug)
              if (!result) {
                item.use = false
              } else {
                categoryPreventWipe = 1
                item.use = true
                value.field === 'stock' || value.field === 'gender' ? this.selectedFiltersPrep[value.field] = item.slug : ''
              }
            })
            if (!categoryPreventWipe) {
              delete this.selectedFiltersPrep[value.field]
            }
          })
          this.otherFilterOptionsData && this.otherFilterOptionsData.forEach((value, key) => {
            value.options.sort((x, y) => {
              return x.use === y.use ? 0 : x.use ? -1 : 1
            })
          })
          this.selectedFilters && this.selectedFilters.price && (this.selectedFilters.price[0] !== this.options.min || this.selectedFilters.price[1] !== this.options.max) ? this.value = [this.selectedFilters.price[0], this.selectedFilters.price[1]] : this.value = this.prices
          setTimeout(function () {
            let elem = document.getElementById('filter')
            if (elem) {
              elem.style.maxHeight = (window.innerHeight - 44) + 'px'
              elem.style.minHeight = (window.innerHeight - 44) + 'px'
            }
            const el2 = document.getElementsByClassName('maxer')
            const el3 = document.getElementsByClassName('filter-opt-area')
            if (el2 && el2.length && el3 && el3.length) {
              el2[0].style.maxHeight = (window.innerHeight - 100) + 'px'
              el2[0].style.minHeight = (window.innerHeight - 100) + 'px'
              el3[0].style.maxHeight = (window.innerHeight - 100) + 'px'
              el3[0].style.minHeight = (window.innerHeight - 100) + 'px'
            }
          }, 350)
          document.body.classList.add('noscroll')
          if (opt === 'age') {
            this.eventHandler(opt)
          }
          window.addEventListener('resize', this.refreshFilter)
        }
      },
      eventHandler (opt) {
        let payload = {
          isLoggedIn: this.authStatus,
          UserId: this.user && this.user.user_id ? this.user.user_id : 'NA',
          UserFirstName: this.user && this.user.firstname ? this.user.firstname : 'NA',
          UserLastName: this.user && this.user.lastname ? this.user.lastname : 'NA',
          UserEmail: this.user && this.user.email ? this.user.email : 'NA',
          Platform: 'WEB'
        }
        if (opt === 'age') {
          this.$store.commit('MOENGAGE_EVENT', {eventName: 'BOTTOM_AGE_FILTER_SHOWN', payload})
        }
        if (opt === 'ageFilterApply') {
          payload.ageGroup = this.selectedFilters.agegroup
          this.$store.commit('MOENGAGE_EVENT', {eventName: 'APPLY_AGE_GROUP_FILTER', payload})
        }
      },
      refreshFilter () {
        let elem = document.getElementById('filter')
        if (elem) {
          elem.style.maxHeight = (window.innerHeight - 44) + 'px'
          elem.style.minHeight = (window.innerHeight - 44) + 'px'
        }
        const el2 = document.getElementsByClassName('maxer')
        const el3 = document.getElementsByClassName('filter-opt-area')
        if (el2 && el2.length && el3 && el3.length) {
          el2[0].style.maxHeight = (window.innerHeight - 100) + 'px'
          el2[0].style.minHeight = (window.innerHeight - 100) + 'px'
          el3[0].style.maxHeight = (window.innerHeight - 100) + 'px'
          el3[0].style.minHeight = (window.innerHeight - 100) + 'px'
        }
      },
      sortMobileHandler (itm) {
        this.selectedFilters.sort = itm.value
        const self = this
        setTimeout(function () {
          self.applyFilters()
        }, 250)
      },
      ageGroupMobileHandler (item) {
        this.selectedFilters.agegroup.push(item.value)
        this.selectedFiltersPrep.agegroup.push(item.value)
        const self = this
        self.applyFilters()
        this.eventHandler('ageFilterApply')
      },
      getSelectedFieldCheck (field, slug) {
        const inputData = this.selectedFilters && this.selectedFilters[field]
        if (typeof inputData === 'string') {
          return this.selectedFilters && this.selectedFilters[field] === slug
        }
        const output = this.selectedFilters && this.selectedFilters[field] && this.selectedFilters[field].filter(itm => {
          return itm === slug
        })
        return Boolean(output && output.length)
      },
      handleRadioSelect (name, slug) {
        const rbs = document.querySelectorAll(`input[name=${name}]`)
        if (rbs && rbs.length) {
          for (const rb of rbs) {
            if (rb.value === slug) {
              rb.checked = true
              this.selectedFiltersPrep[this.otherFilterOptionsData[this.activeFilterTab].field] = slug
            }
          }
        }
      },
      removeFilterChipHandler (item) {
        if (item.field === 'sneaker') {
          this.sneakerValue = []
          this.$parent.sneakerdata = this.sneakerValue
        }
        const popAlias = ['gender', 'stock', 'sort', 'price']
        if (popAlias.includes(item.field.toLowerCase())) {
          const rbs = document.querySelectorAll(`input[name=${item.field}]`)
          if (rbs && rbs.length) {
            for (const rb of rbs) {
              rb.checked = false
            }
          }
          if (item.field === 'price') {
            let filterPriceData = this.filters && this.filters.options && this.filters.options.length && this.filters.options.filter((filtr) => filtr.alias === 'Prices' && filtr.options && filtr.options.length > 0)
            let priceData = filterPriceData && filterPriceData[0] && filterPriceData[0].options
            let priceArr = []
            priceData && priceData.map((item) => { priceArr.push(Number(item.name)) })
            const [minPrice, maxPrice] = this.findMinMax(priceArr)
            if (minPrice > this.options.min || maxPrice < this.options.max) {
              this.value = null
              priceData && priceData.map((item) => { delete item.use })
            } else {
              this.value = [this.options.min, this.options.max]
            }
            if (this.$parent.$parent.isDesktop) {
              this.uncheckPriceRadioButtons()
            }
          }
          item.field === 'sort' ? this.selectedFilters[item.field] = 'DEFAULT' : delete this.selectedFilters[item.field]
        } else {
          this.otherFilterOptionsData && this.otherFilterOptionsData.filter((value, key) => {
            if (value.field === item.field) {
              value.options.map(opt => {
                opt.slug === item.slug ? opt.use = false : ''
              })
              if (this.$parent.$parent.isDesktop) {
                value.showMoreData && value.showMoreData.map(opt => {
                  opt.slug === item.slug ? opt.use = false : ''
                })
              }
            }
          })
        }
        this.applyFilters()
      },
      openSideNav () {
        this.showSideNav = true
        this.$store.commit('GTAG_EVENT', {eventName: 'CLICK_ON_HAMBURGER',
          payload: {
            openSideNave: this.showSideNav,
            User_ID: this.user.user_id || 'NA',
            Platform: 'WEB'
          }
        })
      }
    },
    beforeDestroy: function () {
      $('.page-overlay').removeClass('show')
      $('.navbar')[0].style.display = ''
      document.body.classList.remove('noscroll')
    },
    mounted: function () {
      // this.setGenderFromCache()
      if ($(window).width() > 768) {
        var fw = $('.leftsidebar').width()
        $('.filtersection').css('width', fw)
      } else {
        $('.page-overlay').on('click', this.closeFilterModal)
      }
      if (this.navigatedFromAgeGroup && this.navigatedFromAgeGroup.length && this.isAutoAppliedFilter) {
        this.autoSelectAge = true
      }
    }
  }

</script>

<style lang="css" scoped>
  .activewear-landing-wrapper .filtersection .headig-top,
  .supima-landing-wrapper .filtersection .headig-top {
    background-color: #f1f2f2;
  }
  .winter-landing-wrapper .filtersection .headig-top {
    background-color: #fff;
  }
  .cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}
 /* Mozilla support */
  .maxer {
    scrollbar-color: lightgray #fff !important;
  }
  .filtersection {
    border-right: 1px solid #f2f2f2;
    padding-right: 5px;
    scrollbar-width: none;
  }
  .dash-line {
    width: 100%;
    margin-top: 15px;
    border: 0.5px solid rgb(227, 227, 227) !important;
  }
  .headig-top {
    display: block;
    position: relative;
    font-size: 15px;
    text-transform: uppercase;
    color: rgba(88, 89, 91, 1) !important;
    padding: 12px 3px;
    background: #fff;
    text-decoration: none;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 600;
  }

  .priceColor {
    color: rgba(88, 89, 91, 1) !important;
  }

  .showMore {
    cursor: pointer;
    margin-top: 10px;
    font-size: 15px;
    color: #117a7a;
    margin-left: 27px;
    font-family: 'Source Sans Pro', sans-serif;
  }
  .filtersection::-webkit-scrollbar { width: 0 !important }
  .maxer::-webkit-scrollbar {
    width: 5px;
  }
  .maxer::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  .maxer::-webkit-scrollbar-thumb {
    background: lightgray; 
    border-radius: 10px;
  }
  .maxer::-webkit-scrollbar-thumb:hover {
    background: gray; 
  }
  .color-icon-label {
    width: 15px;
    height: 15px;
    display: inline-block;
    border-radius: 50%;
    background-color: white;
  }
  .color-icon-border {
    border: 1px solid #d6d6d6;
  }
  .label-wrapper {
    gap: 5px;
  }
  .activewear-landing .supima-landing.label-wrapper {
    color: #231f20;
  }
  .activewear-landing .filterbtns button, .supima-landing .filterbtns button {
    background-color: #000;
    border-color: #000;
    color: #fff;
    text-transform: uppercase;
    font-family: 'Oswald';
    line-height: 23px;
    border-radius: 0px;
  }
  .dselect {
    width: 115px;
  }
  .leftsidebar{
    display: flex;
    flex-direction: column;
  }

  .stickyfilter {
    position: sticky;
    top: 85px;
    background: #fff;
  }
  .activewear-landing, .supima-landing, .activewear-landing .card-detail, .supima-landing .card-detail, .activewear-landing input, .supima-landing input, .activewear-landing .maxer, .supima-landing .maxer {
    background-color: #f1f2f2;
  }

  .childAccordian .card {
    border-bottom: 0;
  }

  .childAccordian .card a {
    border-bottom: 0;
    padding: 10px 0;
    text-transform: inherit;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 400;
    color: #000 !important;
  }

  .custaccordian .card-header a[aria-expanded="false"]:before, .custaccordian .mbFaqheader a[aria-expanded="false"]:before,
  .custaccordian .card-header a[aria-expanded="true"]:before, .custaccordian .mbFaqheader a[aria-expanded="true"]:before {
    top: 5px;
  }

  .custaccordian .childAccordian .card-header a[aria-expanded="true"]:before,
  .custaccordian .childAccordian .card-header a[aria-expanded="false"]:before {
    top: 4px;
  }

  .customcheckbox [type="checkbox"]:not(:checked) + label:before, .customcheckbox [type="checkbox"]:checked + label:before {
    top: 0;
  }
  .activewear-landing .customcheckbox [type="checkbox"]:not(:checked) + label:before, .activewear-landing .customcheckbox [type="checkbox"]:checked + label:before {
    background: #f1f2f2;
  }

  .customcheckbox, .customradio {
    line-height: 18px;
  }
  .customcheckbox [type="checkbox"] + label:before {
    top: 0 !important;
  }

  .filtersection {
    overflow-y: scroll;
  }

  .price-slider {
    padding-top: 35px;
    padding-left: 15px;
    padding-right: 20px;
    padding-bottom: 10px;
  }
  /* pretty radio */
  label > input[type="radio"] {
    display: none;
  }
  label > input[type="radio"][disabled] + *::before {
    content: "";
    display: inline-block;
    vertical-align: bottom;
    width: 1rem;
    height: 1rem;
    margin-right: 0.3rem;
    border-radius: 50%;
    border-style: solid;
    border-width: 0.1rem;
    border-color: darkgray;
  }
  label > input[type="radio"] + *::before {
    content: "";
    cursor: pointer;
    display: inline-block;
    vertical-align: bottom;
    width: 1rem;
    height: 1rem;
    margin-right: 0.3rem;
    border-radius: 50%;
    border-style: solid;
    border-width: 0.1rem;
    border-color: lightgray;
  }
  label > input[type="radio"]:checked + * {
    color: teal;
  }
  label > input[type="radio"]:checked + *::before {
    border-color: #117a7a;
    background: #117a7a;
    cursor: pointer;
    background-clip: content-box;
    padding: 1px;
  }
  @media screen and (max-width: 991px) {
    .childAccordian {
      padding: 0 10px;
    }

    .filteroption {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
    .filteroptionsModal {
      overflow-y: scroll;
      border: none;
      max-height: 400px;
    }
    .customcheckbox [type="checkbox"]:checked + label:after, .customradio [type="radio"]:checked + label:after {
      top: 3px;
      left: 2px;
    }
    .filteroption {
      border: none;
    }
  }
  @media only screen and (max-width: 768px) {
    .leftsidebar{
      display: unset;
      flex-direction: unset;
    }
    .color-icon-label {
      width: 24px;
      height: 14px;
      border-radius: initial;
    }
    .customcheckbox {
      line-height: 13px;
    }
    .customcheckbox [type="checkbox"]:not(:checked) + label {
      padding: 0;
    }
    .customcheckbox [type="checkbox"]:not(:checked) + label:before, .customcheckbox [type="checkbox"]:checked + label:before, .customradio [type="radio"]:not(:checked) + label:before, .customradio [type="radio"]:checked + label:before {
      right: 8px !important;
      left: unset !important;
    }
    .customcheckbox [type="checkbox"]:not(:checked) + label:after, .customcheckbox [type="checkbox"]:checked + label:after, .customradio [type="radio"]:not(:checked) + label:after, .customradio [type="radio"]:checked + label:after {
      right: 8px !important;
      left: unset !important;
    }
    .customcheckbox [type="checkbox"]:not(:checked) + label, .customcheckbox [type="checkbox"]:checked + label, .customradio [type="radio"]:not(:checked) + label, .customradio [type="radio"]:checked + label {
      padding: 0 !important;
    }
  }

  .filter-search {
    border-radius: 5px;
    margin-bottom: 15px;
  }
  .filtermobileview {
    background-color: #ffffff;
    height: 100%;
    max-height: 100%;
    width: 100%;
    position: fixed;
    z-index: 9999;
    top: 0;
    transition: 0.3s;
    overflow-x: hidden;
    overflow-y: hidden;
  }
  .card-removeButton {
    color: #117a7a;
    display: inline-block;
    border: none;
    background: transparent;
  }
  .card-removeButton:active{
    outline: none
  }
  .card-removeButton:focus{
    outline: none
  }
  .active-filter-tab-class {
    background: #fff !important;
  }
  .filter-tab {
    background: #e2e2e2;
    border-bottom: 1px solid #fff;
  }
  .filter-wrapper-mobile {
    background: #f2f2f2;
  }
  .filter-opt-area {
    background: #fff;
  }
  .filter-chart-wrapper{
    width: 100%;
    min-height: 100%;
    position: fixed;
    z-index: 999;
    top: 0;
    transition: 0.3s;
    overflow-x: hidden;
    overflow-y: hidden;
  }
  .dark-text {
    color: #161b24;
  }
  .lightDark-text {
    color: #58595b;
    font-size: 14px;
    font-family: 'Source Sans Pro semibold', sans-serif;
  }
  .text-stroke {
    -webkit-text-stroke: 0.25px #ffffff;
    -webkit-font-smoothing: antialiased;
  }
  .dot {
    height: 7px;
    width: 7px;
    background-color: #27867b;
    border-radius: 50%;
    display: inline-block;
  }
  .size-filter .customcheckbox{
    position: relative;
    min-width: 44px;
    height: 30px;
    margin: 5px;
    float: left;
    box-sizing: border-box;
  }
  .size-filter .customcheckbox input {
    position: absolute;
    top: 0;
    left: 0;
    min-width: 44px;
    height: 30px;
    opacity: 0;
    cursor: pointer;
  }
  .size-filter .customcheckbox label {
    justify-content: center;
    padding: 0px 10px !important;
    line-height: 25px;
    border: 2px solid #58595B;
    border-radius: 7px;
  }
  .size-filter .customcheckbox [type="checkbox"]:checked ~ label {
    color: #58595B;
    border: 3px solid #117a7a;
    background-color: #00800014;
  }
  .size-filter .customcheckbox label:before, .size-filter .customcheckbox label:after {
    content:none !important;
  }
  .filter-opt-area {
    overflow-y: auto;
  }
  .count-filter{
    justify-content: space-between;
    display: flex;
    flex: 1;
  }
  .count-filter-label{
    /* max-width: 90%; */
    word-break: break-word;
  }
  .size-count{
    font-size: 12px;
    color: #888;
    margin-left: 3px;
  }
  .count-text {
    font-size: 14px;
    color: #888;
  }
  .price-count {
    display: flex;
    flex: 1;
    justify-content: end;
    color: #888;
  }
  .size-count-filter{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .filter-count-number{
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// filterOptions.vue?b97ad116